import json from "@/data/copy/services-overview-page.json";
import { createCopyGetter } from "./localize-copy";

export const getServicesOverviewPageCopy = /*#__PURE__*/ createCopyGetter(json);
